<template>
  <div v-if="this.has_mollie && !this.is_premium" class="gk-tip gk-tip--warning gk-tip--premium mb-3">
    As a non-Premium user you can send iDEAL links with your invoices until {{ max_free_payments }} invoices are paid via these links.
    You currently have <strong>{{ payments_paid }} out of {{ max_free_payments }} paid</strong>. For unlimited use, please consider <a :href="Urls['subscriptions:manage']()">upgrading!</a>
  </div>
</template>

<script>
import MolliePaymentService from '@/store/services/molliepayment.service';

export default {
  name: 'MolliePaymentsLeft',
  components: {},
  data () {
    return {
      state: 'create',
      is_premium: false,
      has_mollie: false,
      mollie: {},
      payments_paid: 0,
      max_free_payments: 5
    }
  },
  created () {
    MolliePaymentService.getConnectionStatus().then((response) => {
      this.has_mollie = !(response.status === 298 || response.status === 299)
    }).catch((error) => {
      if (error.status == 499) {
        this.has_mollie = true
      }
    })
    MolliePaymentService.getPaymentsLeft().then((response) => {
      this.is_premium = response.data.is_premium
      this.payments_paid = response.data.payments_paid
      this.max_free_payments = response.data.max_free_payments
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>